// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__UuDPj","spin":"Spinner_spin__05dLM"};